/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


export default
{
  Background: 1,
  Foreground: 2,
  Root:       3,
};
